// Catálogo del sello. Para añadir un libro nuevo basta con copiar un bloque
// y cambiar los datos: todas las páginas de la web leen de aquí.
//
// Cuando el libro salga a la venta:
//   1. pon  available: true
//   2. rellena  links  con las URL reales
// No hay que tocar nada más.
//
// Los enlaces se reparten por idioma de la página: la ficha en español
// muestra Amazon.es y Amazon.com —España e Hispanoamérica—, y la ficha en
// alemán muestra Amazon.de. El reparto está en src/pages/BookDetail.jsx.

export const books = [
  {
    slug: "la-vecindad",
    title: "La Vecindad",
    author: "César J. Cárdenas Lara",
    cover: "/portada-la-vecindad.jpg",
    coverSmall: "/portada-la-vecindad-sm.jpg",
    isbn: "978-3-9505928-1-8",
    pages: 176,
    format: "139,7 × 215,9 mm",
    price: "14,29 €",
    bookLanguage: "es",
    year: 2026,
    available: true,
    releaseLabel: { de: "Oktober 2026", es: "Octubre de 2026" },
    links: {
      amazonEs: "https://www.amazon.es/dp/3950592814",
      amazonCom: "https://www.amazon.com/dp/3950592814",
      kindleEs: "https://www.amazon.es/dp/B0HLLBDPQD",
      kindleCom: "https://www.amazon.com/dp/B0HLLBDPQD",
      amazonDe: "https://www.amazon.de/dp/3950592814",
      kindleDe: "https://www.amazon.de/dp/B0HLLBDPQD",
    },
    de: {
      genre: "Kriminalroman",
      tagline: "Bogotá, 1980.",
      blurb: [
        "Im Viertel Las Ferias steht ein Backsteinhaus mit einem hundertfünfzig Meter langen Innenhof, den Zimmern zu beiden Seiten und einem Tor, durch das alle gehen, ohne hinzusehen. In diesem Haus führt alles über denselben Hof: Dort wird gewaschen, gekocht, gestritten — und beobachtet.",
        "Am Montag, dem 25. Februar, verlässt Ana die Schule und kommt nicht nach Hause.",
        "Laura ist die einzige Frau auf der Wache, die den Fall übernimmt. Sie findet Türen, die sich sofort öffnen, freundliche Nachbarn und Antworten, die zu schnell kommen. Während das ganze Land auf eine besetzte Botschaft blickt, schafft es das Verschwinden einer Sechzehnjährigen auf keine einzige Titelseite.",
      ],
      closing:
        "Ein Kriminalroman darüber, was es kostet hinzusehen und was es kostet zu schweigen — und über die unbequeme Gewissheit, dass Schweigen an manchen Orten nicht die Unschuldigen schützt.",
      note:
        "Der Roman erscheint auf Spanisch. Eine deutsche Ausgabe ist in Vorbereitung.",
      setting:
        "Die Handlung spielt in Bogotá, im Viertel Las Ferias, im Februar 1980.",
    },
    es: {
      genre: "Novela negra",
      tagline: "Bogotá, 1980.",
      blurb: [
        "En el barrio Las Ferias hay una casona de ladrillo con un patio de ciento cincuenta metros, las habitaciones a lado y lado y un portón que todo el mundo cruza sin mirar. En la vecindad todo pasa por el mismo patio: allí se lava, se cocina, se discute y se vigila.",
        "El lunes 25 de febrero, Ana sale del colegio y no llega a casa.",
        "Laura es la única mujer de la estación dispuesta a tomar el caso. Encuentra puertas que se abren enseguida, vecinos amables y respuestas que llegan demasiado rápido. Mientras el país entero mira hacia una embajada tomada, la desaparición de una muchacha de dieciséis años no alcanza ninguna primera plana.",
      ],
      closing:
        "Una novela negra sobre lo que cuesta mirar y lo que cuesta callar, y sobre esa certeza incómoda de que, en ciertos lugares, el silencio no protege a los inocentes.",
      note: "La novela se publica en español.",
      setting:
        "La acción transcurre en Bogotá, en el barrio Las Ferias, en febrero de 1980.",
    },
  },
  {
    slug: "diarios-de-familia",
    title: "Diarios de Familia",
    subtitle: "Del cielo al infierno y otros lugares sin retorno",
    author: "César J. Cárdenas Lara",
    cover: "/portada-diarios.jpg",
    coverSmall: "/portada-diarios-sm.jpg",
    isbn: "978-3-9505928-3-2",
    pages: 112,
    format: "139,7 × 215,9 mm",
    price: "10,99 €",
    bookLanguage: "es",
    year: 2026,
    available: true,
    releaseLabel: { de: "Oktober 2026", es: "Octubre de 2026" },
    links: {
      amazonEs: "https://www.amazon.es/dp/3950592830",
      amazonCom: "https://www.amazon.com/dp/3950592830",
      amazonDe: "https://www.amazon.de/dp/3950592830",
    },
    de: {
      genre: "Erinnerungen",
      tagline: "Sieben Stimmen einer einzigen Familie.",
      blurb: [
        "»Diarios de Familia« ist eine Sammlung von Ereignissen und Erfahrungen, die die Mitglieder einer kolumbianischen Familie in einer aufgewühlten und unruhigen Gesellschaft erlebt haben.",
        "Die sieben Mitglieder der Familie — die beiden Eltern und ihre fünf Kinder — entfalten sich und begegnen bruchstückhaft sich selbst, jedes in seiner eigenen Welt und im Lauf seines eigenen Lebens, in Erzählungen, die wahr und beinahe erfunden zugleich sind und die doch zum gemeinsamen Gedächtnis der Familie gehören.",
        "Liebe und Lieblosigkeit, Kriege, Konflikte, Krankheiten, Glaube und Aberglaube sind der Spiegel, der ungeschönt zeigt, was viele und sehr verschiedene Familien erleben oder erlebt haben — und mit ihnen die Gesellschaft Kolumbiens, das sich als Nation behauptet, sich selbst zum Trotz.",
      ],
      closing:
        "Zweite, durchgesehene Auflage — die erste unter eigenem Verlag —, mit den sieben Zeichnungen des Autors, die jedes Kapitel eröffnen.",
      note: "Das Buch erscheint auf Spanisch.",
      setting:
        "Die Handlung spielt in Bogotá, im Cauca und in Boyacá und endet an der Donau, in Österreich.",
    },
    es: {
      genre: "Memoria familiar",
      tagline: "Siete voces de una misma familia.",
      blurb: [
        "«Diarios de Familia» es una miscelánea de sucesos y experiencias vividas por los miembros de una familia colombiana en una sociedad convulsa y agitada.",
        "Los siete miembros de la familia, conformada por los dos padres y sus cinco hijos, se van desenvolviendo y encontrando fragmentariamente consigo mismos en cada uno de sus universos a lo largo de sus vivencias, en relatos verdaderos y casi que ficticios, pero que hacen parte de la memoria conjunta del núcleo familiar.",
        "Amor y desamor, guerras, conflictos, dolencias, creencias y supersticiones, son el espejo que refleja en carne viva lo que experimentan o han experimentado muchas y diferentes familias, junto con los conglomerados sociales en Colombia, la cual se mantiene como nación a pesar de sí misma.",
      ],
      closing:
        "Segunda edición, revisada —la primera bajo sello propio—, con los siete dibujos del autor que abren cada capítulo.",
      note: "El libro se publica en español.",
      setting:
        "La acción transcurre en Bogotá, en el Cauca y en Boyacá, y termina a orillas del Danubio, en Austria.",
    },
  },
  {
    slug: "la-una-izquierda-de-dios",
    title: "La uña izquierda de Dios",
    author: "César J. Cárdenas Lara",
    cover: "/portada-una-izquierda.jpg",
    coverSmall: "/portada-una-izquierda-sm.jpg",
    isbn: "978-3-9505928-0-1",
    pages: 380,
    format: "139,7 × 215,9 mm",
    price: "17,99 €",
    bookLanguage: "es",
    year: 2026,
    available: true,
    releaseLabel: { de: "Oktober 2026", es: "Octubre de 2026" },
    links: {
      amazonEs: "https://www.amazon.es/dp/3950592806",
      amazonCom: "https://www.amazon.com/dp/3950592806",
      amazonDe: "https://www.amazon.de/dp/3950592806",
    },
    // Aviso temporal: la edición en papel acaba de salir y el canal de
    // impresión todavía se está poniendo al día, así que algunas tiendas
    // muestran plazos de entrega disparatados. Borrar este bloque en cuanto
    // Amazon dé una fecha de entrega normal.
    saleNote: {
      de: "Die Druckausgabe ist soeben erschienen; die Lieferzeiten einzelner Shops normalisieren sich in den kommenden Tagen.",
      es: "La edición en papel acaba de salir; los plazos de entrega de algunas tiendas se normalizarán en los próximos días.",
    },
    de: {
      genre: "Historischer Kriminalroman",
      tagline: "Österreich, 1628. Im zehnten Jahr des Dreißigjährigen Krieges.",
      blurb: [
        "Krieg, Pest und Angst haben die Menschen im Machland gelehrt, mit dem Tod zu leben. Doch manche Tote lassen sich nicht einfach begraben.",
        "Als ein persönlicher Verlust dazu zwingt, über das Vertraute hinauszusehen, tauchen Zeichen auf zwischen Dörfern, Wäldern und alten Wegen entlang der Donau. Geheimnisvolle Zeichen, die sich wiederholen. Die Gegend sucht nach einem Schuldigen, wobei sich der Glaube mit der Furcht vereint.",
        "Denn manches bleibt nicht verborgen, weil niemand es gesehen hätte, sondern weil es bequemer ist, dort wegzusehen, wo Hinsehen etwas verändern würde.",
      ],
      closing:
        "Ein historischer Mystery-Roman, durchdrungen von Gothic-Dunkelheit, angesiedelt im Herzen des Dreißigjährigen Krieges, in dem Vernunft, Glaube und Schuld auf eine beunruhigende Frage treffen: Was geschieht, wenn gerade das, was wir zu verstehen glauben, uns den Blick auf die Wahrheit verstellt?",
      note:
        "Der Roman erscheint auf Spanisch. Eine deutsche Ausgabe ist in Vorbereitung.",
      setting:
        "Die Handlung spielt im Machland und im Strudengau: Windegg, Klam, Waldhausen, Grein, Pabneukirchen, Sankt Georgen, Enns und Sankt Thomas am Blasenstein.",
    },
    es: {
      genre: "Novela negra histórica",
      tagline: "Austria, 1628. Décimo año de la Guerra de los Treinta Años.",
      blurb: [
        "La guerra, la peste y el miedo han enseñado a los habitantes del Machland a convivir con la muerte. Pero algunas muertes no se dejan enterrar con facilidad.",
        "Cuando una tragedia personal obliga a mirar más allá de lo conocido, empiezan a aparecer señales que se repiten entre aldeas, bosques y antiguos caminos del Danubio. La comarca busca culpables, y la fe se mezcla con el temor.",
        "Porque hay cosas que permanecen ocultas no porque nadie las haya visto, sino porque resulta más fácil mirar hacia otra parte.",
      ],
      closing:
        "Una novela de misterio histórico y oscuridad gótica ambientada en el corazón de la Guerra de los Treinta Años, donde la razón, la fe y la culpa se enfrentan a una pregunta inquietante: ¿qué sucede cuando aquello que creemos comprender resulta ser exactamente lo que nos impide ver la verdad?",
      note: "La novela se publica en español.",
      setting:
        "La acción transcurre en el Machland y el Strudengau: Windegg, Klam, Waldhausen, Grein, Pabneukirchen, Sankt Georgen, Enns y Sankt Thomas am Blasenstein.",
    },
  },
];

export const findBook = (slug) => books.find((b) => b.slug === slug);
